import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#EAEAEA",
      "fill-rule": "evenodd",
      d: "M3.4 3.838a1.7 1.7 0 0 1 1.7-1.7h3.898c.45 0 .883.18 1.202.498l2.902 2.902a1.7 1.7 0 0 1 .498 1.203v7.297a1.7 1.7 0 0 1-1.7 1.7H5.1a1.7 1.7 0 0 1-1.7-1.7zm1.7 5.1c0-.469.38-.85.85-.85h5.1a.85.85 0 0 1 0 1.7h-5.1a.85.85 0 0 1-.85-.85m.85 2.55a.85.85 0 0 0 0 1.7h5.1a.85.85 0 1 0 0-1.7z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }